@if (popoverVisible$()) {
  <div [class.sol-popover-fixed-position]="fixed$()">
    <div [class]="containerClass$()" [style]="popoverStyle$()" #container>
      <div [class]="popoverClass$()" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
        <div class="sol-popover-content" [style]="contentStyle$()">
          <ng-container #popoverContent />
        </div>
      </div>
    </div>
  </div>
}
